// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 2025.10.15 경영목표 css 디자인 완료 */

.goals-section {
  padding: 60px;
}

/* 2025.10.15 class 변경 */
.goals-container {
  display: flex;
  gap: 60px;
  max-width: 1100px;
  margin: 0 auto;
}

/* 좌측 */
.goals-left {
  flex: 1;
  position: sticky;
  top: 100px;
  align-self: flex-start;
}

.goals-left h2 {
  font-size: 36px;
  font-weight: 900;
  margin-bottom: 20px;
}

.goals-left .intro {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.8;
}

/* 우측 */
.goals-right {
  flex: 2;
}

/* 사훈 / 목표 / 가치관 */
.values {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 60px;
}

.value-item h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}

.value-item p {
  color: #444;
  line-height: 1.6;
}

/* 원형 비전 + 설명 */
.vision-circles {
  gap: 60px;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
  text-align: center;
}

.circle-item {
  flex: 1 1 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.circle {
  width: 160px;
  height: 160px;
  border: 10px solid #001B8B;
  /* 짙은 네이비 */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  color: #001B8B;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
  transition: all 0.3s ease;
}

.circle strong {
  font-size: 20px;
  font-weight: 700;
}

.circle:hover {
  background-color: #001B8B;
  color: #fff;
}

/* 하단 한글 설명 */
.circle-desc {
  background: #f3f3f3;
  padding: 10px 15px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  color: #333;
}

/* 반응형 */
@media (max-width: 900px) {
  /* 2025.10.21 수정 */
  /* .section-container { */
  .goals-container {
    flex-direction: column;
  }

  .goals-left {
    position: static;
    width: 100%;
    margin-bottom: 24px;
  }

  .vision-circles {
    justify-content: center;
  }

  .circle-item {
    width: 80%;
  }

  .circle {
    width: 130px;
    height: 130px;
  }
}`, "",{"version":3,"sources":["webpack://./static/css/goals.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,OAAO;EACP,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,OAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,yBAAyB;EACzB;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":["/* 2025.10.15 경영목표 css 디자인 완료 */\n\n.goals-section {\n  padding: 60px;\n}\n\n/* 2025.10.15 class 변경 */\n.goals-container {\n  display: flex;\n  gap: 60px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n/* 좌측 */\n.goals-left {\n  flex: 1;\n  position: sticky;\n  top: 100px;\n  align-self: flex-start;\n}\n\n.goals-left h2 {\n  font-size: 36px;\n  font-weight: 900;\n  margin-bottom: 20px;\n}\n\n.goals-left .intro {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.8;\n}\n\n/* 우측 */\n.goals-right {\n  flex: 2;\n}\n\n/* 사훈 / 목표 / 가치관 */\n.values {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  margin-bottom: 60px;\n}\n\n.value-item h3 {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.value-item p {\n  color: #444;\n  line-height: 1.6;\n}\n\n/* 원형 비전 + 설명 */\n.vision-circles {\n  gap: 60px;\n  max-width: 1100px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 40px;\n  text-align: center;\n}\n\n.circle-item {\n  flex: 1 1 30%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.circle {\n  width: 160px;\n  height: 160px;\n  border: 10px solid #001B8B;\n  /* 짙은 네이비 */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  color: #001B8B;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.4;\n  transition: all 0.3s ease;\n}\n\n.circle strong {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.circle:hover {\n  background-color: #001B8B;\n  color: #fff;\n}\n\n/* 하단 한글 설명 */\n.circle-desc {\n  background: #f3f3f3;\n  padding: 10px 15px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #333;\n}\n\n/* 반응형 */\n@media (max-width: 900px) {\n  /* 2025.10.21 수정 */\n  /* .section-container { */\n  .goals-container {\n    flex-direction: column;\n  }\n\n  .goals-left {\n    position: static;\n    width: 100%;\n    margin-bottom: 24px;\n  }\n\n  .vision-circles {\n    justify-content: center;\n  }\n\n  .circle-item {\n    width: 80%;\n  }\n\n  .circle {\n    width: 130px;\n    height: 130px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
